import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css';
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import {store} from './redux/store'
import {DevSupport} from "@react-buddy/ide-toolbox";
import ComponentPreviews from "./dev/previews";
import {useInitial} from "./dev";
import {PersistGate} from 'redux-persist/integration/react'
import zhCN from 'antd/lib/locale/zh_CN'
import 'moment/dist/locale/zh-cn'
import {ConfigProvider} from "antd";
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import styled from 'styled-components';


dayjs.locale('zh-cn');


createRoot(document.getElementById('root')).render(

  <Provider store={store}>
    {/*<PersistGate loading={null} persistor={persisstore}>*/}
    <ConfigProvider locale={zhCN}>
      <div >
        {/*<React.StrictMode>*/}
          <App />
        {/*</React.StrictMode>*/}
      </div>
    </ConfigProvider>
    {/*</PersistGate>*/}
  </Provider>

)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

